import { merchantApiClient } from '../../../../redux'

export const GET_DOCUMENTS_BY_AGENT_TYPE_URL = '/api/v1/get-documents'

export const getDocumentByAgentType = () => {
  return merchantApiClient.post(GET_DOCUMENTS_BY_AGENT_TYPE_URL, { page: 'contact-us' })
}
